<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    export let values: [] = [];

    let query = '';

    $: allValues = values;
    $: suggestion = query ? allValues.find((item) => item.toLowerCase().startsWith(query.toLowerCase())) : '';
    $: completion = suggestion ? suggestion.slice(query.length) : '';

    function handleKeydown(e: KeyboardEvent) {
        if ((e.key === 'Tab' || e.key === 'Enter') && suggestion) {
            e.preventDefault();
            query = suggestion;
        }
    }

    $: dispatch('change', query);
</script>

<div class="autocomplete-wrapper">
    <div class="ghost">
        {query}<span class="completion">{completion}</span>
    </div>

    <div class="input">
        <input type="text" bind:value={query} on:keydown={handleKeydown} placeholder="{$_('shared.SEARCH')}..." />
    </div>
</div>

<style>
    .autocomplete-wrapper {
        position: relative;
        margin-left: 16px;
        margin-right: 16px;
    }

    input {
        position: relative;
        background: transparent;
        width: 100%;
        z-index: 2;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .ghost {
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        pointer-events: none;
        width: 100%;
        white-space: pre;
        padding-top: 8px;
    }

    .completion {
        color: #aaa;
    }
</style>
